import { render } from "./stronaOpinie.vue?vue&type=template&id=0754e00e&scoped=true"
import script from "./stronaOpinie.vue?vue&type=script&lang=js"
export * from "./stronaOpinie.vue?vue&type=script&lang=js"

import "./stronaOpinie.vue?vue&type=style&index=0&id=0754e00e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0754e00e"]])

export default __exports__